var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73529 6.76162C3.63031 7.03762 1.25 9.6389 1.25 12.7561V13.3975C1.25 15.6821 2.75252 17.6946 4.94289 18.3438C6.84235 18.9069 8.89788 18.4492 10.379 17.1334L11.4116 16.216C12.0329 15.6642 12.9683 15.6628 13.5912 16.2129L14.6512 17.1491C16.1303 18.4555 18.1784 18.9072 20.0698 18.3443C22.2531 17.6946 23.75 15.6875 23.75 13.4095V12.7589C23.75 9.64009 21.3685 7.03752 18.262 6.76138L16.4432 6.59971C13.8196 6.3665 11.1804 6.3665 8.55676 6.59972L6.73529 6.76162ZM8.9068 9.946C11.2984 9.73341 13.7042 9.73341 16.0958 9.946L17.7741 10.0952C18.0491 10.1196 18.2919 9.91647 18.3164 9.64141C18.3408 9.36636 18.1377 9.12356 17.8626 9.09911L16.1843 8.94993C13.7338 8.7321 11.2688 8.7321 8.81826 8.94993L7.13743 9.09933C6.86237 9.12378 6.65922 9.36658 6.68367 9.64164C6.70812 9.9167 6.95091 10.1199 7.22597 10.0954L8.9068 9.946Z",
    fill: "#BE4236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/Glasses.1046a2810dfa8e32df0f0817f841fbb1.svg";
export { ForwardRef as ReactComponent };